import React from "react";
// import classNames from "classnames";
// import Nouislider from "react-nouislider";
import numeral from 'numeral';
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import withStyles from "@material-ui/core/styles/withStyles";
import Datetime from "react-datetime";
// import Checkbox from "@material-ui/core/Checkbox";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
import Snackbar from '@material-ui/core/Snackbar';
import FormControl from "@material-ui/core/FormControl";

// import Check from "@material-ui/icons/Check";

import Accordion from "../../../components/Accordion/Accordion.jsx";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardHeader from "../../../components/Card/CardHeader.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";
import Clearfix from "../../../components/Clearfix/Clearfix.jsx";
import CustomInput from "../../../components/CustomInput/CustomInput";
import Info from "../../../components/Typography/Info.jsx";

import vecLogo from "../../../assets/img/Header-Logo.png";

import styles from "../../../assets/jss/material-kit-pro-react/views/ecommerceSections/productsStyle.jsx";

import CustomNotification from "../../LandingPage/Sections/CustomNotification";
import SectionFiltered from "./SectionFiltered";

import { filterTours, clearFilter } from "../../../actions/filterActions";
import { STATICS_URL } from '../../../config/constants';

const yesterday = Datetime.moment().subtract( 1, 'day' );
const nextYear = moment().add(1, 'year').get('year');
const endLimitDate = Datetime.moment(`02/01/${nextYear}`, 'DD/MM/YYYY');
const validDate = function( current ){
    return current.isAfter( yesterday ) && current.isBefore( endLimitDate );
};

class SectionCatalog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checkIn: '',  // Siempre debe ser un moment
            checkOut: '',  // Siempre debe ser un moment
            numPersons: '',
            suggestions: [],
            openDatePicker: false,
            checked: [],
            priceRange: [25000, 500000],
            errors: {}
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!!localStorage.getItem('FILTERS')) {
            let filters = JSON.parse(localStorage.getItem('FILTERS'));

            if (nextProps.filtersReducer.filteredTours.length===0 && filters.showNotification===true) {
                this.handleClickNotification('No encontramos tours que cumplan los criterios de busqueda. Por favor intenta con datos diferentes', 'warning');
            } else {
                this.handleClickNotification('Tours filtrados exitosamente', 'success');
            }

            setTimeout(() => {
                filters.showNotification = false;
                localStorage.setItem('FILTERS', JSON.stringify(filters));
            }, 3000);
        }
    }

    componentDidMount() {
        const { filteredTours } = this.props.filtersReducer;

        if (
            !!localStorage.getItem('FILTERS')
            && JSON.parse(localStorage.getItem('FILTERS')).showNotification===true
            && filteredTours.length===0
        ) {
            this.handleClickNotification('No encontramos tours que cumplan los criterios de busqueda. Por favor intenta con datos diferentes', 'warning');
            let filters = JSON.parse(localStorage.getItem('FILTERS'));
            setTimeout(() => {
                filters.showNotification = false;
                localStorage.setItem('FILTERS', JSON.stringify(filters));
            }, 3000);
        }

        if (!!localStorage.getItem('FILTERS')) {
            let filters = JSON.parse(localStorage.getItem('FILTERS'));
            this.setState({ checkIn: moment(filters.checkIn), checkOut: moment(filters.checkOut), numPersons: filters.numPersons })
        }
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    // onChangeSlide = () => {
    //     if (this.refs.NoUiSlider) {
    //         let newArray = this.refs.NoUiSlider.slider.get();
    //         newArray[0] = Number(newArray[0].slice(0, 3));
    //         newArray[1] = Number(newArray[1].slice(0, 3));
    //         let currencyLow = this.refs.priceLow.dataset.currency;
    //         let currencyHigh = this.refs.priceLow.dataset.currency;
    //         this.refs.priceLow.innerHTML = currencyLow + newArray[0];
    //         this.refs.priceHigh.innerHTML = currencyHigh + newArray[1];
    //     }
    // };

    handleToggle(value) {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        currentIndex===-1 ? newChecked.push(value) : newChecked.splice(currentIndex, 1);

        this.setState({ checked: newChecked });
    }

    onChangeCustomInput = () => e => {
        if (!!e.target.id) {
            this.setState({ [e.target.id]: e.target.value, errors: {} });
        } else {
            console.error('Error actualizando la informacion ingresada', 'error');
        }
    };

    onChangeDateInput = (inputName, e) => {
        if (!!e && !!inputName) {
            this.setState({ [inputName]: e, errors: {}, openDatePicker: false });
        } else {
            this.setState({ [inputName]: '', errors: {}, openDatePicker: false });
        }
    };

    onSubmit = e => {
        e.preventDefault();

        const { checkIn, checkOut, numPersons } = this.state;

        let auxNumPersons = (numPersons<=0) ? 1 : numPersons;

        if (checkIn!=='' || checkOut!=='') {
            if (checkIn.isBefore(checkOut)) {

                let filterData = {
                    checkIn: checkIn.format("DD")+"%2F"+checkIn.format("MM")+"%2F"+checkIn.format("YYYY"),
                    checkOut: checkOut.format("DD")+"%2F"+checkOut.format("MM")+"%2F"+checkOut.format("YYYY"),
                    numPersons: auxNumPersons
                };

                localStorage.setItem('FILTERS', JSON.stringify({numPersons: filterData.numPersons, checkIn, checkOut, showNotification: true}));
                this.props.filterTours(filterData, this.props.history);
            } else {
                let errors = {
                    checkIn: "Fecha no válida",
                    checkOut: "Fecha no válida"
                };
                this.setState({ errors });
                this.handleClickNotification('El Check-In debe ser anterior al Check-Out', 'warning');
            }
        } else {
            this.handleClickNotification('Selecciona las fechas de CheckIn y CheckOut', 'warning');
            let errors = {
                checkIn: "Selecciona una fecha",
                checkOut: "Selecciona una fecha"
            };
            this.setState({ errors });
        }
    };

    render() {
        const { classes, tours, filtersReducer } = this.props;

        const { errors } = this.state;

        let tourCards = (
            tours.map(tour =>
                <GridItem md={12} sm={12} key={tour._id}>
                    <Card plain blog className={classes.card}>
                        <GridContainer>
                            <GridItem xs={5} sm={5} md={4} className={classes.vecImgContainer}>
                                <CardHeader image plain>
                                    {/**
                                     TODO: Revisar asunto slugs para URL del tour
                                     */}
                                    <Link to={`/tour/${tour._id}`}>
                                        <img
                                            className={classes.vecImg}
                                            src={tour.photos.length>0 ? STATICS_URL+tour.photos[0].path : vecLogo}
                                            alt={tour.name}
                                        />
                                    </Link>
                                    {/* Shadow img */}
                                    {tour.photos.length>0 ?
                                        <div
                                            className={classes.coloredShadow+" "+classes.vecImg}
                                            style={{ backgroundImage: `url(${tour.photos.length>0 ? STATICS_URL+tour.photos[0].path : vecLogo})`, opacity: 1 }}
                                        />
                                        :
                                        null
                                    }
                                    {/* End Shadow img */}
                                </CardHeader>
                            </GridItem>

                            <GridItem xs={7} sm={7} md={6}>
                                <Info>
                                    <h6 className={classes.cardCategory}>{tour.location.city.name}, {tour.location.department.name}</h6>
                                </Info>
                                <Link to={`/tour/${tour._id}`}>
                                    <h3 className={classes.cardTitle}>{tour.name}</h3>
                                </Link>
                                
                                <p className={classes.author}><strong>Duración: {tour.duration} día(s)</strong></p>
                                <p>{tour.shortDescription}</p>
                                {tour.observations ? <p className={classes.vecAdvice}>{tour.observations}</p> : null}
                            </GridItem>

                            <GridItem xs={12} sm={12} md={2}>
                                {isMobile ?
                                    <div className={classes.vecPriceContainer}>
                                        <GridContainer>
                                            <GridItem xs={8} sm={8} md={8}>
                                                <span>{tour.min_persons} - {tour.max_persons} pasajeros</span>
                                                <br/>
                                                <span>Desde</span>
                                                {(!!tour.pricing && tour.pricing.low_season) ?
                                                    <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(tour.pricing.low_season).format('0,0')}</h3>
                                                    :
                                                    <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(tour.pricing.high_season).format('0,0')}</h3>
                                                }
                                                <div>
                                                    <span>Por persona (IVA no incl.)</span>
                                                </div>
                                            </GridItem>
                                            <GridItem xs={4} sm={4} md={4}>
                                                <br/>
                                                <br/>
                                                <Link to={`/tour/${tour._id}`}>
                                                    <Button color="success">
                                                        Elegir
                                                    </Button>
                                                </Link>
                                            </GridItem>
                                        </GridContainer>
                                    </div>
                                    :
                                    <div className={classes.vecPriceContainer}>
                                        <span>{tour.min_persons} - {tour.max_persons} pasajeros</span>
                                        <br/>
                                        <br/>
                                        <span>Desde</span>
                                        {(!!tour.pricing && tour.pricing.low_season) ?
                                            <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(tour.pricing.low_season).format('0,0')}</h3>
                                            :
                                            <h3 className={classes.vecPriceNumber}><small>COP$</small>{numeral(tour.pricing.high_season).format('0,0')}</h3>
                                        }

                                        <div>
                                            <span>Por persona <br/> (IVA no incl.)</span>
                                        </div>
                                        <Link to={`/tour/${tour._id}`}>
                                            <Button color="success">
                                                Elegir
                                            </Button>
                                        </Link>
                                    </div>
                                }
                            </GridItem>
                        </GridContainer>
                    </Card>

                    <hr/>
                    <br/>
                    <br/>

                </GridItem>
            )
        );


        return (
            <div>
                <div className={classes.section}>
                    <div className={classes.container}>

                        <GridContainer>
                            {/* Filter search */}
                            <GridItem xs={12} sm={12} md={3} lg={3}>
                                <Card plain>
                                    {/* Custom Notification */}
                                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                                        <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                                    </Snackbar>
                                    {/* End Custom Notification */}

                                    <CardBody className={classes.cardBodyRefine}>
                                        <form onSubmit={this.onSubmit}>

                                            {/**
                                             TODO: Reactivar el acordeón de filtros
                                             */}
                                            {/*
                                    esto va dentro del collapse

                                    {
                                                title: "Rango de Precios",
                                                content: (
                                                    <CardBody className={classes.cardBodyRefine}>
                                                        <span
                                                            ref="priceLow"
                                                            data-currency="COP$"
                                                            className={classNames(
                                                                classes.pullLeft,
                                                                classes.priceSlider
                                                            )}
                                                        >
                                                            COP$ 25000
                                                        </span>
                                                        <span
                                                            ref="priceHigh"
                                                            data-currency="COP$"
                                                            className={classNames(
                                                                classes.pullRight,
                                                                classes.priceSlider
                                                            )}
                                                        >
                                                            COP$ 500000
                                                        </span>
                                                        <div className="slider slider-success">
                                                            <Nouislider
                                                                start={this.state.priceRange}
                                                                connect={true}
                                                                range={{ min: 25000, max: 500000 }}
                                                                onUpdate={this.onChangeSlide}
                                                                ref="NoUiSlider"
                                                            />
                                                        </div>
                                                    </CardBody>
                                                )
                                            },
                                            {
                                                title: "Calificación",
                                                content: (
                                                    <div className={classes.customExpandPanel}>
                                                        <div
                                                            className={
                                                                classes.checkboxAndRadio +
                                                                " " +
                                                                classes.checkboxAndRadioHorizontal
                                                            }
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(27)}
                                                                        checked={
                                                                            this.state.checked.indexOf(27) !== -1
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="All"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(28)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Black"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(29)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Blue"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(30)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Brown"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(31)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Gray"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(32)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Green"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(33)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Neutrals"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(34)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Purple"
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            },
                                            {
                                                title: "Servicios",
                                                content: (
                                                    <div className={classes.customExpandPanel}>
                                                        <div
                                                            className={
                                                                classes.checkboxAndRadio +
                                                                " " +
                                                                classes.checkboxAndRadioHorizontal
                                                            }
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(27)}
                                                                        checked={
                                                                            this.state.checked.indexOf(27) !== -1
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="All"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(28)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Black"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(29)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Blue"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(30)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Brown"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(31)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Gray"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(32)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Green"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(33)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Neutrals"
                                                            />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        tabIndex={-1}
                                                                        onClick={() => this.handleToggle(34)}
                                                                        checkedIcon={
                                                                            <Check className={classes.checkedIcon} />
                                                                        }
                                                                        icon={
                                                                            <Check
                                                                                className={classes.uncheckedIcon}
                                                                            />
                                                                        }
                                                                        classes={{ checked: classes.checked }}
                                                                    />
                                                                }
                                                                classes={{ label: classes.label }}
                                                                label="Purple"
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                    */}

                                            {isMobile ?
                                                <Accordion
                                                    active={[]}
                                                    activeColor="success"
                                                    collapses={[
                                                        {
                                                            title: "Fechas",
                                                            content: (
                                                                <div className="date-input-spaced">
                                                                    <Datetime
                                                                        id="checkIn"
                                                                        value={this.state.checkIn}
                                                                        closeOnSelect={true}
                                                                        closeOnTab={true}
                                                                        className={classes.compressedInput}
                                                                        dateFormat="DD/MM/YYYY"
                                                                        timeFormat={false}
                                                                        isValidDate={ validDate }
                                                                        onChange={ e => this.onChangeDateInput("checkIn", e) }
                                                                        inputProps={{
                                                                            placeholder: "Check-In",
                                                                            name: "checkIn",
                                                                            autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    <small className={classes.errorDisplay}>{!!errors.checkIn ? errors.checkIn : null}</small>

                                                                    <Datetime
                                                                        id="checkOut"
                                                                        value={this.state.checkOut}
                                                                        closeOnSelect={true}
                                                                        closeOnTab={true}
                                                                        className={classes.compressedInput}
                                                                        dateFormat="DD/MM/YYYY"
                                                                        timeFormat={false}
                                                                        isValidDate={ validDate }
                                                                        onChange={ e => this.onChangeDateInput("checkOut", e) }
                                                                        inputProps={{
                                                                            placeholder: "Check-Out",
                                                                            name: "checkOut",
                                                                            autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    <small className={classes.errorDisplay}>{!!errors.checkOut ? errors.checkOut : null}</small>
                                                                </div>
                                                            )
                                                        },
                                                        {
                                                            title: "Datos hospedaje",
                                                            content: (
                                                                <div>
                                                                    <CustomInput
                                                                        id = "numPersons"
                                                                        formControlProps={{ fullWidth: true, className: classes.compressedInput3 }}
                                                                        inputProps={{
                                                                            type: "number",
                                                                            value: this.state.numPersons,
                                                                            onChange: this.onChangeCustomInput(),
                                                                            placeholder: "Num. Huéspedes",
                                                                            autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    <small className={classes.errorDisplay}>{!!errors.numPersons ? errors.numPersons : null}</small>
                                                                </div>
                                                            )
                                                        }
                                                    ]}
                                                />

                                                :

                                                <div>
                                                    <FormControl fullWidth className={classes.selectFormControl}>
                                                        <Datetime
                                                            id="checkIn"
                                                            value={this.state.checkIn}
                                                            closeOnSelect={true}
                                                            closeOnTab={true}
                                                            className={classes.compressedInput}
                                                            dateFormat="DD/MM/YYYY"
                                                            timeFormat={false}
                                                            isValidDate={ validDate }
                                                            onChange={ e => this.onChangeDateInput("checkIn", e) }
                                                            inputProps={{
                                                                placeholder: "Check-In",
                                                                name: "checkIn",
                                                                autoComplete: "off"
                                                            }}
                                                        />
                                                        <small className={classes.errorDisplay}>{!!errors.checkIn ? errors.checkIn : null}</small>
                                                    </FormControl>

                                                    <FormControl fullWidth className={classes.selectFormControl}>
                                                        <Datetime
                                                            id="checkOut"
                                                            value={this.state.checkOut}
                                                            closeOnSelect={true}
                                                            closeOnTab={true}
                                                            className={classes.compressedInput}
                                                            dateFormat="DD/MM/YYYY"
                                                            timeFormat={false}
                                                            isValidDate={ validDate }
                                                            onChange={ e => this.onChangeDateInput("checkOut", e) }
                                                            inputProps={{
                                                                placeholder: "Check-Out",
                                                                name: "checkOut",
                                                                autoComplete: "off"
                                                            }}
                                                        />
                                                        <small className={classes.errorDisplay}>{!!errors.checkOut ? errors.checkOut : null}</small>
                                                    </FormControl>

                                                    <FormControl fullWidth className={classes.selectFormControl}>
                                                        <CustomInput
                                                            id = "numPersons"
                                                            formControlProps={{ fullWidth: true, className: classes.compressedInput3 }}
                                                            inputProps={{
                                                                type: "number",
                                                                value: this.state.numPersons,
                                                                onChange: this.onChangeCustomInput(),
                                                                placeholder: "Num. Huéspedes",
                                                                autoComplete: "off"
                                                            }}
                                                        />
                                                        <small className={classes.errorDisplay}>{!!errors.numPersons ? errors.numPersons : null}</small>
                                                    </FormControl>
                                                </div>
                                            }

                                            <h4 className={`${classes.cardTitle} ${classes.textLeft}`}>
                                                <Button  color="success" type="submit">
                                                    Filtrar
                                                </Button>
                                                <Clearfix />
                                            </h4>

                                        </form>
                                    </CardBody>
                                </Card>
                            </GridItem>
                            {/* End Filter search */}
                            {/* Products catalog */}
                            <GridItem xs={12} sm={12} md={9} lg={9}>

                                {filtersReducer.filteredTours.length>0 ?
                                    <SectionFiltered />
                                    :
                                    null
                                }

                                {filtersReducer.filteredTours.length>0 ?
                                    <div>
                                        <br/>
                                        <hr/>
                                        <h2>También te puede interesar:</h2>
                                    </div>
                                    :
                                    <h2>Catálogo</h2>
                                }

                                <GridContainer>
                                    {/* Product card */}
                                    {tourCards}
                                    {/* End Product card */}

                                    {/*<GridItem
                                    md={12}
                                    sm={12}
                                    className={classNames(classes.mlAuto, classes.mrAuto)}
                                >
                                    <Button round color="success">
                                        Cargar más
                                    </Button>
                                </GridItem>*/}
                                </GridContainer>
                            </GridItem>
                            {/* End Products catalog */}
                        </GridContainer>
                    </div>
                </div>
            </div>
        );
    }
}

SectionCatalog.propTypes = {
    filterTours: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    filtersReducer: PropTypes.object
};

const mapStateToProps = state => ({
    filtersReducer: state.filtersReducer
});

export default connect(mapStateToProps, { filterTours, clearFilter })( withStyles(styles)(SectionCatalog) );



// WEBPACK FOOTER //
// ./src/views/ToursPage/Sections/SectionCatalog.jsx